import { createContext } from "react";

const DrawerContext = createContext({
  isOpen: false,
  onClose: () => undefined,
});

export default DrawerContext;
